import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../../../auth/auth.service';
import { UserRoleAppModuleModel } from '../../../../model/user_role_module.model';

@Component({
  selector: 'app-user-right-delete-dialog',
  templateUrl: './user-right-delete-dialog.component.html',
  styleUrls: ['./user-right-delete-dialog.component.css']
})
export class UserRightDeleteDialogComponent implements OnInit {

    selectedItem:UserRoleAppModuleModel;
  mItems:UserRoleAppModuleModel[]; 
  errorMessage: string = '';
	isLoading: boolean = true;

  constructor(
    private location: Location,
		private mApiService:AuthService,
		private _snackBar: MatSnackBar,
		private dialogRef: MatDialogRef<UserRightDeleteDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.selectedItem = this.data;
  }

  
  
removeItemInList(item:UserRoleAppModuleModel){

  let index:number=this.mItems.indexOf(item);

  if(index>0)
  {
    this.mItems.splice(index,1);
  }


}


close() {
  this.dialogRef.close();
}
  
saveDelete(){
      

  // add a new access right
   this.mApiService
   .removeUserRoleModule(this.selectedItem)
   .subscribe(
    p=>{

     this.removeItemInList(this.selectedItem);
      this.selectedItem=null;
      this.dialogRef.close();
     
      
      },
    e => this.errorMessage = e,
    ()=>this.isLoading=false
  )

}

}
